import { States } from '../../../../../../constants';

export const anyApply = [
  {
    id: 'neighborhoodBased',
    name: 'neighborhoodBased',
    label: 'Neighborhood Based',
  },
  {
    id: 'chdoDesignation',
    name: 'chdoDesignation',
    label: 'CHDO Designation',
  },
  {
    id: 'faithBased',
    name: 'faithBased',
    label: 'Faith Based',
  },
  {
    id: 'minorityOwnedCertified',
    name: 'minorityOwnedCertified',
    label: 'Certified as a Minority Owned',
  },
  {
    id: 'veteranOwned',
    name: 'veteranOwned',
    label: 'Veteran Owned',
  },
  {
    id: 'veteranOwnedCertified',
    name: 'veteranOwnedCertified',
    label: 'Certified as Veterans Owned Based',
  },
  {
    id: 'bipocOwned',
    name: 'bipocOwned',
    label: 'BIPOC Owned',
  },
  {
    id: 'bipocLed',
    name: 'bipocLed',
    label: 'BIPOC Led',
  },
  {
    id: 'nonProfit',
    name: 'nonProfit',
    label: 'Non-Profit',
  },
];

const validStateOptions: string[] = [];
States.forEach((state) => validStateOptions.push(state.name));

export const legislativeDistrict = [
  '1-Allegany',
  '2-AnneArundel',
  '3-BaltimoreCity',
  '4-Baltimore',
  '5-Calvert',
  '6-Caroline',
  '7-Carroll',
  '8-Cecil',
  '9-Charles',
  '10-Dorchester',
  '11-Frederick',
  '12-Garrett',
  '13-Harford',
  '14-Howard',
  '15-Kent',
  '16-Montgomery',
  '17-PrinceGeorge’s',
  '18-QueenAnne’s',
  '19-St.Mary’s',
  '20-Somerset',
  '21-Talbot',
  '22-Washington',
  '23-Wicomico',
  '24-Worchester',
];
